import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import auth from '../../services/authentication';
import { useDispatch, useSelector } from 'react-redux';
import validator from 'validator';
import { StoreState } from '../../type.d';
import { changeSayThanksModalState, changeFeedbackModalState } from '../../store/actionCreators';
import handsPhone from '../../../images/hands-phone.svg';
import closeIcon from '../../../images/close-icon.svg';
import * as Styled from './FeedbackModalStyles';
import UserService from '../../services/UserService';
import AttitudeSelect from './AttitudeSelect';

const formFields = {
  topic: '',
  email: '',
  message: '',
}

const FeedbackModal = React.memo(() => {
  const [formState, setFormState] = useState(formFields);
  const [formErrors, setFormErrors] = useState(formFields);
  const [generalError, setGeneralError] = useState('');
  const [attitude, setAttitude] = useState(null);

  const dispatch = useDispatch();

  const { feedbackModal } = useSelector((rootReducer: StoreState) => rootReducer.reducer);
  const onFormSubmit = async (e:any) => {
    e.preventDefault();
    if (validForm()) {
      const response = await UserService.submitUserFeedback({
        ...formState,
        attitude: attitude || 0,
      }, auth.isAuthenticated());
      if (response.data && response.data.success) {
        setFormState(formFields);
        setFormErrors(formFields);
        dispatch(changeFeedbackModalState());
        dispatch(changeSayThanksModalState());
      } else {
        setGeneralError('Ooops! Something went wrong. Please try again later.')
      }
    }
  }
  const onChangeInput = (e:any) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: '',
    });
    setGeneralError('');
  }
  const validForm = () => {
    const errors = {
      topic: '',
      message: '',
      email: '',
    };
    let hasErrors = false;
    if (!formState.topic) {
      errors.topic = 'Please add a feedback topic';
      hasErrors = true;
    }
    if (!formState.message) {
      errors.message = 'Please add a feedback message';
      hasErrors = true;
    }
    if (!validator.isEmail(formState.email)) {
      errors.email = 'Please add a valid email address';
      hasErrors = true;
    }
    if (!formState.email) {
      errors.email = 'Please fill in your email address';
      hasErrors = true;
    }
    setFormErrors(errors);
    return !hasErrors;
  }

  return (
    <Styled.Container>
      <Modal
        show={feedbackModal}
        onHide={() => changeFeedbackModalState()}
        animation={false}
        centered
        size='lg'
        contentClassName='ModalContent'
        dialogClassName='ModalDialog'
      >
        <Styled.StyledModalBody>
          <Styled.StyledModalBtn onClick={() => dispatch(changeFeedbackModalState())}
            className='HeaderBtn'
          >
            <Styled.StyledImg src={closeIcon} alt='Close' />
          </Styled.StyledModalBtn>
          <Styled.Container className='Wrapper'>
            <Styled.Container className='LeftBlock'>
              <Styled.StyledH1>
                Feedback
              </Styled.StyledH1>
              <Styled.Container className='ImgAlign'>
                <Styled.StyledImg src={handsPhone} alt='Hands Phone' />
              </Styled.Container>
            </Styled.Container>
            <Styled.Container className='RightBlock'>
              <Styled.StyledH1 className="d-lg-none ml-0">
                Feedback
              </Styled.StyledH1>
              <Styled.StyledH2 className="modal-title">
                Help Trova Improve
              </Styled.StyledH2>
              <Form onSubmit={onFormSubmit}>
                <Form.Group>
                  <Styled.StyledFormLabel>Topic</Styled.StyledFormLabel>
                  <Styled.StyledFormControl
                    type="text"
                    name="topic"
                    value={formState.topic}
                    onChange={onChangeInput}
                  />
                  <Styled.ErrorText>
                    {formErrors.topic}
                  </Styled.ErrorText>
                  <Styled.StyledFormLabel>Email</Styled.StyledFormLabel>
                  <Styled.StyledFormControl
                    type="text"
                    name="email"
                    value={formState.email}
                    onChange={onChangeInput}
                  />
                  <Styled.ErrorText>
                    {formErrors.email}
                  </Styled.ErrorText>
                  <AttitudeSelect selected={attitude} onChange={setAttitude} />
                  <Styled.StyledFormLabel>Description</Styled.StyledFormLabel>
                  <Styled.StyledTextarea
                    cols={30}
                    rows={4}
                    name="message"
                    value={formState.message}
                    onChange={onChangeInput}
                  />
                  <Styled.ErrorText>
                    {formErrors.message}
                  </Styled.ErrorText>
                </Form.Group>
                <Styled.ErrorText>
                  {generalError}
                </Styled.ErrorText>
                <Styled.StyledModalBtn
                  className='FeedbackFooter'
                  variant='primary'
                  type="submit"
                >
                  Submit
                </Styled.StyledModalBtn>
              </Form>
            </Styled.Container>
          </Styled.Container>
        </Styled.StyledModalBody>
      </Modal>
    </Styled.Container>
  );
})

export default FeedbackModal;